import styled from "styled-components";
import { CenterFlexColumn, FlexRow } from "styles/layout";
import { Theme } from "theme";

export const TournamentContainer = styled(FlexRow)`
  padding: 4px ${Theme.smallPanelPadding};
  line-height: 100%;
`;

export const TournamentTrigrams = styled(CenterFlexColumn)`
  row-gap: 4px;
  width: 50px;
  font-size: 11.5pt;
`;

export const TournamentLogoContainer = styled.div`
  width: 75px;
  height: 75px;
  margin-left: auto;
`;
